import apiClient from './apiClient';

const BASE = '/importaciones';

// Importación por lote: subir el archivo deja un BORRADOR (no crea nada del dominio), se corrige
// desde la pantalla, y recién `confirmarLote` aplica. Ver ImportacionLoteController en el backend.

/** Sube y parsea el archivo. Devuelve el lote en borrador con el conteo por estado. */
export async function crearLote(archivo, tipo = 'TURNOS_ANSES') {
    const formData = new FormData();
    formData.append('archivo', archivo);
    formData.append('tipo', tipo);
    const { data } = await apiClient.post(BASE, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
}

export async function listarLotes() {
    const { data } = await apiClient.get(BASE);
    return Array.isArray(data) ? data : [];
}

/**
 * Borra una importación que no se aplicó, con sus filas. Para cuando se subió el archivo
 * equivocado. Un lote ya confirmado el backend lo rechaza.
 */
export async function eliminarLote(idLote) {
    await apiClient.delete(`${BASE}/${idLote}`);
}

export async function obtenerLote(idLote) {
    const { data } = await apiClient.get(`${BASE}/${idLote}`);
    return data;
}

/** Las filas del lote; `estado` filtra por los chips (OK, ADVERTENCIA, ERROR, IGNORADA, APLICADA). */
export async function listarFilas(idLote, estado) {
    const { data } = await apiClient.get(`${BASE}/${idLote}/filas`, {
        params: estado ? { estado } : {},
    });
    return Array.isArray(data) ? data : [];
}

/**
 * Corrige campos de una fila. Se manda SOLO lo editado, no la fila entera: el backend lo guarda
 * aparte de lo interpretado para que una corrección sobreviva a reinterpretar la fila.
 */
export async function editarFila(idLote, idFila, edicion) {
    const { data } = await apiClient.patch(`${BASE}/${idLote}/filas/${idFila}`, edicion);
    return data;
}

/** Migra una fila suelta que quedó pendiente de un lote ya confirmado (y se corrigió después). */
export async function aplicarFila(idLote, idFila) {
    const { data } = await apiClient.post(`${BASE}/${idLote}/filas/${idFila}/aplicar`);
    return data;
}

export async function ignorarFila(idLote, idFila, ignorar = true) {
    const { data } = await apiClient.patch(`${BASE}/${idLote}/filas/${idFila}/ignorar`, { ignorar });
    return data;
}

/** Aplica la misma corrección a todas las filas con problema en ese campo. */
export async function corregirEnMasa(idLote, campo, edicion) {
    const { data } = await apiClient.patch(`${BASE}/${idLote}/correccion-masiva`, { campo, edicion });
    return data;
}

/** Aplica el lote. Es la única llamada irreversible. */
export async function confirmarLote(idLote) {
    const { data } = await apiClient.post(`${BASE}/${idLote}/confirmar`);
    return data;
}
